var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrends = function SvgTrends(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1a1 1 0 0 0-2 0v19a1 1 0 0 0 1 1h19a1 1 0 1 0 0-2H2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4a1 1 0 1 0 0 2h2.586L11 9.586 9.707 8.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 1 0 1.414 1.414L9 10.414l1.293 1.293a1 1 0 0 0 1.414 0L16 7.414V10a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1z"
  })));
};
export default SvgTrends;